export const COMPLETE_REQUEST_TYPES = Object.freeze({
  document: {
    title: 'Company Document',
    color: '#3b82f6'
  },
  sequence: {
    title: 'In Service',
    color: '#10b981'
  },
  associate_document: {
    title: 'Attached Document',
    color: '#6C69FF'
  }
})

export const COMPLETE_REQUEST_STATUSES = Object.freeze({
  cancelled: {
    title: 'Rejected',
    color: '#ef4444'
  },
  planned: {
    title: 'Plan',
    color: '#6C69FF'
  },
  completed: {
    title: 'Completed',
    color: '#10b981'
  },
  in_progress: {
    title: 'In Progress',
    color: '#3b82f6'
  },
  initial: {
    title: 'Initial',
    color: '#6b7280'
  }
})

export const COMPLETE_REQUEST_EXECUTION_STATUS = Object.freeze({
  initial: {
    title: 'Not started',
    color: '#6b7280'
  },
  in_progress: {
    title: 'In Progress',
    color: '#3b82f6'
  },
  completed: {
    title: 'In Review',
    color: '#f59e0b'
  },
  approved: {
    title: 'Approved',
    color: '#10b981'
  },
  rejected: {
    title: 'Declined',
    color: '#ef4444'
  },
  deprecated: {
    title: 'Deprecated',
    color: '#6b7280'
  }
})
